var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 2.25C6.78921 2.25 7.125 2.58579 7.125 3V11.5263C7.125 14.2588 9.315 16.4605 12 16.4605C14.685 16.4605 16.875 14.2588 16.875 11.5263V3C16.875 2.58579 17.2108 2.25 17.625 2.25C18.0392 2.25 18.375 2.58579 18.375 3V11.5263C18.375 15.0724 15.5282 17.9605 12 17.9605C8.4718 17.9605 5.625 15.0724 5.625 11.5263V3C5.625 2.58579 5.96079 2.25 6.375 2.25ZM3.75 21C3.75 20.5858 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 20.5858 20.25 21C20.25 21.4142 19.9142 21.75 19.5 21.75H4.5C4.08579 21.75 3.75 21.4142 3.75 21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.a91eabc6da5c3606423fdc6906aba99d.svg";
export { ForwardRef as ReactComponent };